import React, { useMemo, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import PropTypes from 'prop-types';
import * as Yup from 'yup';
// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// material
import { Box, Button } from '@mui/material'
import { LoadingButton } from '@mui/lab';
import FormProvider, { RHFTextField } from '../../../components/hook-form';
import ModalPopup from '../../../components/modal-popup/modalpopup';
import AppCache from '../../../services/appcache';
import MastersService from '../../../services/masters.services';
import { handleError } from '../../../auth/utils';

// --------------------------------------------------------------------------------------------------------

DeleteReasonPopup.propTypes = {
    confirm: PropTypes.func,
    masterName: PropTypes.string,
    selectedRow: PropTypes.array,
};
// --------------------------------------------------------------------------------------------------------

const buttonStyle = {
    backgroundColor: 'common.white',
    color: 'common.black',
    border: '1.5px solid',
    borderColor: 'grey.300',
    mr: 1,
    ':hover': {
        backgroundColor: 'common.white',
        boxShadow: 10,
    }
}
// ----------------------------------------------------------------------------------------------------------------

export default function DeleteReasonPopup({ confirm, masterName, selectedRow }) {

    const navigate = useNavigate();

    const onClickNo = () => {
        confirm(false);
    };

    const DeleteSchema = Yup.object().shape({
        reason: Yup.string().required('Reason is required').min(20, 'Too Short!'),
    });

    const defaultValues = useMemo(() => ({
        reason: '',
    }), []);

    const methods = useForm({
        resolver: yupResolver(DeleteSchema),
        defaultValues,
    });

    const {
        handleSubmit,
        formState: { isSubmitting },
    } = methods;

    const onSubmit = (data) => {
        const currentLoggedInUser = AppCache.GetCurrentLoggedInUser();
        try {
            const payload = {
                "masterName": masterName,
                "operation": "delete",
                "changedDate": new Date(),
                "reason": data.reason,
                "changedBy": currentLoggedInUser.DistId,
                "ids": selectedRow
            }
            MastersService.DeleteMasterAndHistoryRecords(payload)
                .then((response) => {
                    if (response.status === 200) {
                        console.log('Deleted')
                        confirm(true);
                    }
                    else {
                        // TODO: Handle error and show it to user
                        console.log("error")
                    }
                })
                               .catch(_error => {
                    handleError(_error, navigate, "", "");
                });

        }
        catch (error) {
            console.error('error', error);
        }
    };

    return (
        <div>
            <ModalPopup cancel={onClickNo} title='Reason for Delete' sx={{ left: '50%', transform: 'translate(-50%,-50%)', width: 400, height: 290 }} >
                <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                    <RHFTextField name="reason" label="Reason" multiline rows={4} sx={{ mt: 2 }} />

                    <Box sx={{ position: 'absolute', bottom: 16, right: 16 }} >
                        <Button variant="contained" onClick={onClickNo} sx={buttonStyle}> No  </Button>

                        <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
                            Yes
                        </LoadingButton>
                    </Box>
                </FormProvider>
            </ModalPopup>
        </div >
    )
}